module.exports = __webpack_public_path__ + "img/responsaveis_temas-EQTL_GO.42f2c17c.png";